export const combineFormElements = (elements) =>
    <div className=''>
        {[...elements]}
    </div>